import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { PriceDisplay } from './PriceDisplay';
export function PricingSection() {
  return <section className="bg-[#F5F5F5] py-16 px-4 md:py-20" data-id="element-238">
      <div className="max-w-[800px] mx-auto text-center" data-id="element-239">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-gray-100 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-240">
          <div className="absolute top-0 left-0 w-full h-2 bg-[#00A86B]" data-id="element-241"></div>

          <div className="inline-block bg-[#FFF3D6] text-yellow-800 font-heading font-bold text-sm px-4 py-1.5 rounded-full mb-4" data-id="element-242">
            🔥 OFERTA SOLO POR HOY
          </div>

          <div className="mb-1" data-id="element-243">
            <span className="text-red-500 line-through text-2xl font-heading font-bold" data-id="element-244">$35.000</span>
          </div>

          <div className="mb-2" data-id="element-245">
            <PriceDisplay amount={14500} className="font-heading font-bold text-[52px] text-[#00A86B] leading-none" data-id="element-246" />
          </div>

          <p className="text-gray-500 italic text-sm md:text-base mb-8" data-id="element-247">
            Menos que una rotisería para dos. Y lo usás todos los días.
          </p>

          <div className="w-full max-w-md mx-auto mb-6" data-id="element-248">
            <CTAButton data-id="element-249">QUIERO LAS RECETAS AHORA →</CTAButton>
          </div>

          {/* Bloque de pagos */}
          <div className="border-t border-gray-100 pt-5" data-id="element-250">
            <div className="flex justify-center items-center gap-5 mb-3" data-id="element-251">

              {/* Mercado Pago logo PNG real */}
              <img src="https://i.ibb.co/FLNVkjC4/Mercado-Pago-idw-Afz-US5-S-1.png" alt="Mercado Pago" style={{
              height: '32px',
              objectFit: 'contain',
              flexShrink: 0
            }} data-id="element-252" />

              <div className="w-px h-8 bg-gray-200" data-id="element-253"></div>

              {/* Mastercard logo oficial */}
              <svg height="36" viewBox="0 0 116.5 72" xmlns="http://www.w3.org/2000/svg" style={{
              flexShrink: 0
            }} data-id="element-254">
                <rect x="0" y="0" width="116.5" height="72" rx="6" fill="white" stroke="#e5e7eb" strokeWidth="1" data-id="element-255" />
                <rect x="42.5" y="7.7" fill="#FF5F00" width="31.5" height="56.6" data-id="element-256" />
                <path fill="#EB001B" d="M44.5,36c0-11,5.1-21.5,13.7-28.3C42.6-4.6,20-1.9,7.7,13.8C-4.6,29.4-1.9,52,13.8,64.3c13.1,10.3,31.4,10.3,44.5,0C49.6,57.5,44.5,47,44.5,36z" data-id="element-257" />
                <path fill="#F79E1B" d="M116.5,36c0,19.9-16.1,36-36,36c-8.1,0-15.9-2.7-22.2-7.7c15.6-12.3,18.3-34.9,6-50.6c-1.8-2.2-3.8-4.3-6-6c15.6-12.3,38.3-9.6,50.5,6.1C113.8,20.1,116.5,27.9,116.5,36z" data-id="element-258" />
              </svg>

              <div className="w-px h-8 bg-gray-200" data-id="element-259"></div>

              {/* Visa logo oficial */}
              <svg height="28" viewBox="0 0 262.3 85" xmlns="http://www.w3.org/2000/svg" style={{
              flexShrink: 0
            }} data-id="element-260">
                <path fill="#1434CB" d="M170.9,0c-18.6,0-35.3,9.7-35.3,27.5c0,20.5,29.5,21.9,29.5,32.1c0,4.3-5,8.2-13.4,8.2c-12,0-21-5.4-21-5.4l-3.8,18c0,0,10.3,4.6,24.1,4.6c20.4,0,36.4-10.1,36.4-28.3c0-21.6-29.6-23-29.6-32.5c0-3.4,4.1-7.1,12.5-7.1c9.5,0,17.3,3.9,17.3,3.9l3.8-17.4C191.3,3.6,182.8,0,170.9,0zM0.5,1.3L0,3.9c0,0,7.8,1.4,14.9,4.3c9.1,3.3,9.7,5.2,11.3,11.1l16.7,64.3h22.4L99.6,1.3H77.3l-22.1,56l-9-47.5c-0.8-5.4-5-8.5-10.2-8.5C36,1.3,0.5,1.3,0.5,1.3zM108.6,1.3L91.1,83.6h21.3l17.4-82.3L108.6,1.3zM227.2,1.3c-5.1,0-7.8,2.7-9.8,7.5l-31.2,74.8h22.3l4.3-12.5H240l2.6,12.5h19.7L245.2,1.3L227.2,1.3zM230.1,23.6l6.6,30.9H219L230.1,23.6z" data-id="element-261" />
              </svg>

            </div>

            <p className="text-gray-400 text-xs mb-4 flex items-center justify-center gap-1" data-id="element-262">
              🔒 Plataforma segura. Aboná con Mercado Pago.
            </p>

            <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-6 text-sm text-gray-600 font-medium" data-id="element-263">
              <div className="flex items-center gap-1.5" data-id="element-264">
                <svg className="w-4 h-4 text-[#00A86B]" fill="currentColor" viewBox="0 0 20 20" data-id="element-265"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414L8.414 15l-4.121-4.121a1 1 0 011.414-1.414L8.414 12.172l7.879-7.879a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-266" /></svg>
                <span data-id="element-267">Compra 100% segura</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-268">
                <svg className="w-4 h-4 text-[#00A86B]" fill="currentColor" viewBox="0 0 20 20" data-id="element-269"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414L8.414 15l-4.121-4.121a1 1 0 011.414-1.414L8.414 12.172l7.879-7.879a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-270" /></svg>
                <span data-id="element-271">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-272">
                <svg className="w-4 h-4 text-[#00A86B]" fill="currentColor" viewBox="0 0 20 20" data-id="element-273"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414L8.414 15l-4.121-4.121a1 1 0 011.414-1.414L8.414 12.172l7.879-7.879a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-274" /></svg>
                <span data-id="element-275">Descarga digital</span>
              </div>
            </div>
          </div>

        </motion.div>
      </div>
    </section>;
}